import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import "../styles/review.css";

const Review = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const {
        currentUser,
        verifyTransactionPin
    } = useContext(AuthContext);

    const [showPinModal, setShowPinModal] = useState(false);
    const [pinInput, setPinInput] = useState("");
    const [pinError, setPinError] = useState("");
    const [isPaying, setIsPaying] = useState(false);

    if (!state || !state.type || !state.details) {
        return <div className="p-4 text-center">❌ Invalid review data. Go back and try again.</div>;
    }

    const { type, details } = state;

    const handleConfirm = () => {
        if (!isPaying) setShowPinModal(true);
    };

    const validateAndProceed = async () => {
        if (isPaying || pinInput.length < 4) return;

        setIsPaying(true);
        setPinError("");

        try {
            // 🔐 1. Verify PIN
            const result = await verifyTransactionPin(pinInput);

            if (!result.success) {
                setPinError(result.error || "❌ Incorrect Transaction PIN");
                setIsPaying(false);
                return;
            }

            // 💰 2. Check for balance
            const amount = parseFloat(details.amount || "0");

            if (currentUser?.balance < amount) {
                setPinError("❌ Insufficient balance");
                setIsPaying(false);
                return;
            }

            // ✅ 3. Navigate to Receipt
            setShowPinModal(false);
            navigate("/receipt", {
                state: {
                    status: "processing",
                    type,
                    details
                }
            });
        } catch (err) {
            console.error(err);
            setPinError("❌ Something went wrong. Please try again.");
            setIsPaying(false);
        }
    };

    return (
        <div className="review-container">

            <div className="review-details">
                {Object.entries(details)
                    .filter(([key]) => !["payeePhoneNo", "payeeBankCode", "accessToken", "planCode", "meterType"].includes(key))
                    .map(([key, value]) => {
                        const isAmountField = key.toLowerCase().includes("amount") || key.toLowerCase().includes("cost") || key.toLowerCase().includes("price");
                        let displayValue = isAmountField ? `₦${Number(value).toLocaleString()}` : value;

                        // Add note for totalCost
                        if (key === "totalCost") {
                            displayValue += " (20% withdrawal charges)";
                        }
                        return (
                            <div key={key} className="review-item">
                                <span className="review-label">{key.replace(/([A-Z])/g, ' $1')}:</span>
                                <span className="review-value">{displayValue}</span>
                            </div>
                        );
                    })}

            </div>

            <div className="review-actions">
                <button
                    onClick={handleConfirm}
                    className="confirm-btn"
                    disabled={isPaying}
                >
                    Confirm Purchase
                </button>
            </div>


            {showPinModal && (
                <div className="pin-modal-overlay">
                    <div className="pin-modal">
                        <button
                            className="review-close-btn"
                            onClick={() => !isPaying && setShowPinModal(false)}
                        >
                            ×
                        </button>

                        <h3 className="modal-title">Enter Transaction PIN</h3>

                        <input
                            type="password"                 // 👈 hides the characters
                            inputMode="numeric"             // 👈 still brings numeric keypad on mobile
                            pattern="[0-9]*"
                            className="pin-input styled-input"
                            maxLength={4}
                            placeholder="Enter 4-digit PIN"
                            value={pinInput}
                            onChange={(e) => setPinInput(e.target.value)}
                            disabled={isPaying}
                        />


                        {pinError && <p className="pin-error">{pinError}</p>}

                        <button
                            className="pay-btn pay-p-btn"
                            onClick={validateAndProceed}
                            disabled={isPaying || pinInput.length < 4}
                        >
                            {isPaying ? "Processing..." : "Pay"}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Review;
